import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "card p-2 d-flex flex-row flex-wrap" }
const _hoisted_5 = { class: "ms-2" }
const _hoisted_6 = { class: "ms-2" }
const _hoisted_7 = { class: "d-flex justify-content-end my-4 row p-2" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_DynamicForms = _resolveComponent("DynamicForms")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", {
    id: "formData",
    class: "form-view container pb-5",
    onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveAndNavigate && _ctx.saveAndNavigate(...args)), ["enter"]))
  }, [
    _createVNode(_component_Breadcrumb),
    _createVNode(_component_Wizzard, { "current-page": "form" }),
    _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Emissão de Certificado", -1)),
    (_ctx.form.isPj && !_ctx.form.isSSL)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _cache[2] || (_cache[2] = [
          _createTextVNode(" Agora é a hora de inserir os dados da "),
          _createElementVNode("span", { class: "fw-600" }, "empresa", -1),
          _createTextVNode(" do solicitante ")
        ])))
      : _createCommentVNode("", true),
    (!_ctx.form.isPj && !_ctx.form.isSSL)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _cache[3] || (_cache[3] = [
          _createTextVNode(" Agora é a hora de inserir os dados "),
          _createElementVNode("span", { class: "fw-600" }, "pessoais", -1),
          _createTextVNode(" do solicitante ")
        ])))
      : _createCommentVNode("", true),
    (_ctx.form.isSSL)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Agora é hora inserir os dados do Certificado Digital "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-600" }, "Voucher", -1)),
        _createTextVNode(": " + _toDisplayString(_ctx.getSolicitation.voucher), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fw-600" }, "Certificado Adquirido", -1)),
        _createTextVNode(": " + _toDisplayString(_ctx.getProduto.nome), 1)
      ])
    ]),
    (_openBlock(), _createBlock(_component_DynamicForms, {
      key: _ctx.dynamicCount,
      ref: "dynamicComponent",
      fields: _ctx.form.fields,
      onIsValid: _ctx.handleIsValid
    }, null, 8, ["fields", "onIsValid"])),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: _normalizeClass(["col-sm-12 col-md-2 btn", !_ctx.isValid ? 'btn-secondary' : 'btn-primary']),
        type: "button",
        disabled: !_ctx.isValid,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAndNavigate && _ctx.saveAndNavigate(...args)))
      }, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
        _createVNode(_component_Icon, { name: "arrow-right" })
      ], 10, _hoisted_8)
    ]),
    _createVNode(_component_Contact)
  ], 32))
}